export const wearablesMetadata = [
  {
    id: 244,
    name: 'beta pass',
    trim: '',
    set: 'Doodlebot',
    set_type: 'Utility',
    body_position: '',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmdsq27zMFJiZiertMg5nAJp9mbS9sRKhDYo1kPgfFwhdM',
  },
  {
    id: 246,
    name: 'starry bandana',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRzgRXagviGCFQZK12iZ442RjUxV53kQttmHRSf4uQFsS',
  },
  {
    id: 247,
    name: 'starry bedsheet cape',
    trim: 'red',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmb8moGzcXK2PbCn9cZieXw9Yhi8Atug5rft4MshDyEWCC',
  },
  {
    id: 248,
    name: 'heart emote',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'scene',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmQZLREjpKKSUqjqAMBPDqATXwPZR2Wrynj1w6JX33r6AT',
  },
  {
    id: 249,
    name: 'portal face',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUSTNeCxvM1KPvTXCLXXUr1A7zC6qaxPFqVthMDovk7ke',
  },
  {
    id: 250,
    name: 'fairy wings',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmPq8JzhXKwrYTLtwZ42ecQFSQPUCL7dn92icdeQb5Js1o',
  },
  {
    id: 251,
    name: 'touch grass boa',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmW43Yv8pS7Jv1MLahNowrppEztgNMbHEN99pv4iwm8wrB',
  },
  {
    id: 252,
    name: 'cucumber headphones',
    trim: 'green',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmSR7ZCVWcDfBSYqWRp4nWsaD6EpBmLoiYs9ochysymNpV',
  },
  {
    id: 253,
    name: 'condiment jetpack',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSRsknCBHrJ4CAtq6zEMEBwN6BYARpgrrmdQmL7qMi862',
  },
  {
    id: 254,
    name: 'over-ear headphones',
    trim: 'fiesta',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmcCJ4wXJyYC1z7PsM8aSVqehdZqG3ucciG4uFeSaDVWE5',
  },
  {
    id: 255,
    name: 'verified headphones',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmdAKDSTPy93FJH3WkuCUStfUy9ha2cy75njD9X8frUM2M',
  },
  {
    id: 256,
    name: 'skelly bandana',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRzF6zpH6on3kYj9pTiA47NUQq9mpzbKjapnZ7pbwVDpU',
  },
  {
    id: 257,
    name: 'starry bandana',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRMBAQYt363vZhnzRAS3gUxuLdvnfChmeeaoWimfBuZyv',
  },
  {
    id: 258,
    name: "alien's headphones",
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmdJsxHdFgG3xtZvP4Vi5spuggbnRTapcBv6jFgowo5md6',
  },
  {
    id: 259,
    name: 'star glasses',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmWgcBfMKVTPBA5Zn7e4a9wuq13jgcE5tApqj6h1te4skG',
  },
  {
    id: 260,
    name: 'holographic jetpack',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYQB441ekmr8TDCyzjZozUPcr8DeDuwFWgLnVtmDnVV9u',
  },
  {
    id: 261,
    name: 'hydro jetpack',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcTfWzXHSUhHQq42x1vFCC3yzy9Xzyo63PjJCAn7zvGWZ',
  },
  {
    id: 262,
    name: "wrestler's glasses",
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmYLbhxLVrKpX4j3NibxPrBNdWkBtSnGoz17TVqwjyVPQz',
  },
  {
    id: 263,
    name: 'butterfly',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'scene',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmQ5F7rcM97dt7WeBFJSZsBjvrdVmhFTZhNvooWBrQxnaq',
  },
  {
    id: 264,
    name: 'fuzzy-friend earmuffs',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmVMsMe5AVaBGtMzEDLiM7CSgfXFvFCRZGZG4cTJjABR1u',
  },
  {
    id: 265,
    name: 'fuzzy-friend earmuffs',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUj8477FKL6GHhcrSReRYFDo4tcf1J3a8P6jdXhzBJ4or',
  },
  {
    id: 266,
    name: 'slim watch',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'arm',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZu3jaLr1a2kC5GUS5G9nUHfQRiLfuQQN2qg24xzJ8LKP',
  },
  {
    id: 267,
    name: 'fancy rings',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'fingers',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbU3jC2swk92TfG2ezWHszw2V4adQFBDQb4nBbyEFWevH',
  },
  {
    id: 268,
    name: 'sling case',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYQJMDQRysSGzoH36Pv9EuR2E2xkQGu5Dvy3AcEUtPuiV',
  },
  {
    id: 269,
    name: 'over-ear headphones',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmRDdQuiuqFfXCC6TcLtGh8wWwL1uPQsGZLt9ioGD4XFpK',
  },
  {
    id: 270,
    name: 'heart glasses',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmTDeFrTRaVgWT3URe36EUyBWuNe5JmPkk2a8ajCctSMr7',
  },
  {
    id: 271,
    name: 'poet glasses',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbxsJ12v2qrfTDTv1XZzWsF8eBjS8gP8CrFadYdjiU4Gi',
  },
  {
    id: 272,
    name: 'far-out glasses',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmevjdcEyGwrHs9hnw7gexwfaBc4LKHapEU5b7scPDw973',
  },
  {
    id: 273,
    name: 'worm',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'scene',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPF5mcSopZFg7ADhbc7eamLVrhKZsFE4ioFbQVrkqB4wD',
  },
  {
    id: 274,
    name: 'on-ear headphones',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmaggvJwqhFQnbXXN2hBAdoFgSz93ko78kdmVjhpQB1rfX',
  },
  {
    id: 275,
    name: 'on-ear headphones',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmRWhbPSR9A5GwPhyu1V5z1EK7cnsc3LcaaPCHsSwDYkQZ',
  },
  {
    id: 276,
    name: 'slim shades',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'Qmd9thLpsCvghYuzPgmx1yUUFS6tnr7KqWfWHd6gfzs3ju',
  },
  {
    id: 277,
    name: 'double-piercings',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmdvHQZijUcvGBgZGTC8TkepSBuCXSnhDFfE9fV52cwsmz',
  },
  {
    id: 278,
    name: "alchemist's goggles",
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmfK3VFjF5CbaGVnHP5A6cFnE8P1WhAEjxqs3jKfhjEmYU',
  },
  {
    id: 279,
    name: 'galaxy head',
    trim: 'multi-colored',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSJ4VfV2ttcyXP9EHS2HpPoWJNhZMAhQPfMJt7vaMBg2h',
  },
  {
    id: 280,
    name: 'smart watch',
    trim: 'multi-colored',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'arm',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUCk18n4CN3hJXzx2rJD3HvTRCsjYSiVysjGi1Z5dXnQd',
  },
  {
    id: 281,
    name: 'pot head',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcRFQU9y62RB1oNpsvSHs9wEmZJ1nFM7cDV3QEwGqzZfb',
  },
  {
    id: 282,
    name: 'pot head',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSX8pZLXhqYkThynT81LzpMsnqK8byJpDtxvh7rgMf2mG',
  },
  {
    id: 283,
    name: 'daisy shades',
    trim: 'multi-colored',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'Qmf1EVWT794r8vrxXqkK6fobfxsUBwYzMWogra4KUk5fa9',
  },
  {
    id: 284,
    name: 'monocle',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUS68rUuwPNCMpvTwFb5fn3FcEvGvdmuyrL6KCfww7tNY',
  },
  {
    id: 285,
    name: 'breakfast headphones',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmRu9tKsy44m2M7sS7TohTXNUEGvF9b6D71vJXGHkYumye',
  },
  {
    id: 286,
    name: 'bow tie',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZ87Z7Q9Ewr8qJqKoQesrpCAaHmCgJzh3d6abjVWc1BjY',
  },
  {
    id: 287,
    name: 'bow tie',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmbGAMg5h9nH7fQDWVib6rQD57UXqxrcchgaehuB7AAZxE',
  },
  {
    id: 288,
    name: 'diamond ring',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'finger',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmU4KuUTUZBGU1n4jc6BmN2kP5YxCdXnB17Fh7EJquW9WU',
  },
  {
    id: 289,
    name: 'cyber phone',
    trim: 'tokyo pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmc7ujMc6gpxeeLUMYze9YJS8TZxkLoajdSzh974YQJ9qu',
  },
  {
    id: 290,
    name: 'fanny pack',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTpKW4FHNyiNeErHYymwD5cqQm8o9BbwLXQHihumpyGYt',
  },
  {
    id: 291,
    name: 'streamer headphones',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ears',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmVhUoc5CZvs8WZaMX5B4WpbGgkH6LEUivL3rtD8UEcSGi',
  },
  {
    id: 292,
    name: 'binoculars',
    trim: 'tokyo pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'accessory',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmWg4Qg64uu3uw9FqscZipmCjQnsX6gEDYMCrGN1muoYpH',
  },
  {
    id: 293,
    name: "wizard's wand",
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'hand',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRsssF4j49qmC4Vi37JCpxhrDbuvX1wsEZwX2CNEJ5oQp',
  },
  {
    id: 294,
    name: 'spa mask',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmaqUYgJSJ2apYdQtoxBARUEy3giwWnRiwGFBhyU4imQsu',
  },
  {
    id: 295,
    name: 'pencil',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'ear',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmcff46m3F8t2V5DMcDGhhQx3DVoqZdkZJFQvgj2Zprhb6',
  },
  {
    id: 296,
    name: 'toque',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmP9oX34MQnKZ1NwZ7PTb12zf8KYMGZkYrD15VZ99usE4d',
  },
  {
    id: 297,
    name: "runner's cap",
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYeetnfGBYhHx43ehqZBX5BKG4qmktntQ5kDXXp5JbanJ',
  },
  {
    id: 298,
    name: 'chicken head',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYAscTz6uAZectBMbKoTJcEuEFBxBXskekq8jbiLmWGTe',
  },
  {
    id: 299,
    name: 'floppy beanie',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUrvNo99VE3YFL1CmYBxseJmUaHQ5p3h4s4Pxii5egR7T',
  },
  {
    id: 300,
    name: 'floppy beanie',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYiWpzhPMoWZQFG7zP8LnHhhjdpLfHSvfWQs7rDCEZNzu',
  },
  {
    id: 301,
    name: 'floppy beanie',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmarD5dtE8GSCt2795ZiewjWiS9k8fCctPhfYcRNnqfNYh',
  },
  {
    id: 302,
    name: 'egg head',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmXgRHJH1oPRiTaEHiVQCS2bw1MvfWW286n3DiQb7SVp7r',
  },
  {
    id: 303,
    name: "explorer's hat",
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmctpBcLLdrSQRxdSZiHdb9ANQN1Ffk6zcTVYpWVkQJkLT',
  },
  {
    id: 304,
    name: 'head in the clouds',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSV9DArKzZhQGSVfT8GJCquj8G8BksPEACHNi6TyTm99K',
  },
  {
    id: 305,
    name: 'pigeon hood',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSSaSAQ5m3roDStbnQad6HWaVZ1gH5qX2ibEpr7zyiD5A',
  },
  {
    id: 306,
    name: 'traffic cone',
    trim: 'orange',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmVN2utStsqgKJSXPuzT4picmzKGcKvV5Pdjg25CGpRzzM',
  },
  {
    id: 307,
    name: 'spaghetti hat',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWtmibmtY3gJw4tiy2XsCVqgGKqjA6HDy7M1pCKzuR4dP',
  },
  {
    id: 308,
    name: 'umbrella hat',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWfW6c5ffKmC3fp6zPa5HuRgb8HhG98xQV4cCsWGDkJyU',
  },
  {
    id: 309,
    name: 'toaster head',
    trim: '',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcLgL8ZvcsximgDLPf2y19ZHPvoaPm8CWLGfjZ7nteqMw',
  },
  {
    id: 310,
    name: 'paper hat',
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTZZHGVbeSUk6A7UNxoL2G2RTUXgAew1Z2wTj4sNhdG1i',
  },
  {
    id: 311,
    name: 'fancy cactus hat',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmQatMHjKr3htaCgi4eZR3V7T4oNao2xbr8KimJBCpraBh',
  },
  {
    id: 312,
    name: 'sundae hat',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRkkvb4WDq6oZcGY7XyKgj1YJMaFcuHPFLvamPBc9BNza',
  },
  {
    id: 313,
    name: 'fish head',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcCCqoJkjgv4CXEovSo6St8QNPgCSVJBaihDUxzC38iuK',
  },
  {
    id: 314,
    name: 'pollen head',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmR8XG86RMPhGGNtpos4hwHuei1BHgHtvvvbTx9fXVP45R',
  },
  {
    id: 315,
    name: 'counting sheep',
    trim: 'multi-colored',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmXALJXxetns5FYDLUZZ97dPVB7GzxfpZfLPzLwWeR77MB',
  },
  {
    id: 316,
    name: 'helicopter hat',
    trim: 'coastal classic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYw1QhrugvFsYXFQHURrLqsY4L2NPP3GSaRvLojjkQq4W',
  },
  {
    id: 317,
    name: 'sippy cap',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmdXpf2g2iGpKUWyzZLw3BayBgmump6FcHz8LQiKRRugRi',
  },
  {
    id: 318,
    name: 'television head',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTzkUnngYJmGQGGRzpecWdE34GvNM3AajrTHLJnS3wb2j',
  },
  {
    id: 319,
    name: 'backward cap',
    trim: 'fiesta',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcGJ18V7YuB9NwL1axuzUh8mhSCvXExWTgyvWukiDHXfG',
  },
  {
    id: 320,
    name: 'fish bag',
    trim: 'orange',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZL5iv8EgwgYt1zqpwpZgMCHiUFrGWpG5bu14YgsMJi5N',
  },
  {
    id: 321,
    name: 'fish bag',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmbAFdyZESoGM6oyca4bfguqaWL83MVnJVEZmNqJwzXSQX',
  },
  {
    id: 322,
    name: 'shady head',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmaxRtq56Tst6oM6SmaDHroP7WhQXbGgFWNM1nJgZz8NmH',
  },
  {
    id: 323,
    name: 'sudsy duck',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmY4A1MkQLYe2ABR7Pwi9UkRDwxddHr5qJCV74m1oeZPBY',
  },
  {
    id: 324,
    name: 'louise head scarf',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZ9ZPJeswxUDthfSaM1PhfZ7MP837NEVf2CNTC1qmHEV9',
  },
  {
    id: 325,
    name: 'moto helmet',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmbc9SNeKwxxQBXRkpC8NM6obynBiok5mwnn32yi4UeRdU',
  },
  {
    id: 326,
    name: 'puffball beanie',
    trim: 'coastal classic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRaC2Sk7KD93HHRXVyzBr8JhRZDAKHK3uVuxReQXBxHRA',
  },
  {
    id: 327,
    name: 'sock puppet head',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSWVpUG4BRSAv6uR4xjngkSTvpCuD6nNAgW6EPUM9uVAx',
  },
  {
    id: 328,
    name: 'birds nest',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTyQ5MjMXNyfz3cLbX8Puw9RYQYqmuQniR5vwu2hZLGrW',
  },
  {
    id: 329,
    name: 'double birds nest',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmU6xYxyTTxEcTgde55rSZr5tWjx7zgK7QKs21EjpuoPgk',
  },
  {
    id: 330,
    name: 'brainbot headpiece',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmX51Mfk5HnqFimg59yzVQ8y336cRfKdoqU18pCA7JjVMW',
  },
  {
    id: 331,
    name: 'sleeping cap',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWdHQ4EgMErGwWoqriWYktSyc94fMpokUxjSfH5pwVVEb',
  },
  {
    id: 332,
    name: 'fuzzy cap',
    trim: 'magic garden',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYcchGr9rQYpHXSkyC6y2itLCJEuYWSAQ1ANuTk4UAvmD',
  },
  {
    id: 333,
    name: 'western hat',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRN3721on2peWTjj1p6ujGC5ts86BBkoFC15uvkhDwW6N',
  },
  {
    id: 334,
    name: 'verified mask',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'head',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmNpeLTjex1m5ybgMHx4ZzSDLDFHdjo8XYsGKXjKnh28Fx',
  },
  {
    id: 335,
    name: 'tie-dye tee',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmdLzKiHfBs7VPbZSLCHCD3E9SQCaL6KNvKkTebAsxKe1o',
  },
  {
    id: 336,
    name: 'tie-dye swirl tee',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPMJAeNdrXZhCVLpALDUJtti6ytR8wNo8rTE2xfsbhCQk',
  },
  {
    id: 337,
    name: 'emotional longsleeve',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTa1W1BE3Zcj65cgtLnJuHBtzPmcoDpVrsZPcs1RWz9Pe',
  },
  {
    id: 338,
    name: 'emotional longsleeve',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmdWwssteFu8f25SomrvMTfTEPjCBHVo1eUL8hksFa8WSC',
  },
  {
    id: 339,
    name: 'bomber jacket',
    trim: 'fiesta',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZhLCjeQtuGG29HRbVtosP2rkjkYdQdXy9enWvfSWbTJP',
  },
  {
    id: 340,
    name: 'collared zip',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmbKUsFKfW2apX67YRSv1vi7mkhK92ZRbzACWXFYZ3etRd',
  },
  {
    id: 341,
    name: 'collared zip',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmW5Z6LMAmuo9tdYjTfDNgzaoLVkLs9BTqnfpDzLAr6Tb2',
  },
  {
    id: 342,
    name: 'spotted longsleeve tee',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPBVxmyceqj7wR35XXq5sK6Gwea7qioNshAxCoY4vXBDw',
  },
  {
    id: 343,
    name: 'happy logo tee',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmQy3AzaGHYCTav8aAqFhLKkhkdjVJxe2ZvoXyuwwSF7Cu',
  },
  {
    id: 344,
    name: 'poop logo tee',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmX7efJGii7zXy4M8HJjRod9AyPU8e6qmktucNEM7yfXW3',
  },
  {
    id: 345,
    name: 'leopard hoodie',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSHwMytWq6ZV36QxpAHEbikoS24fZBqieHcohSCH5XvYn',
  },
  {
    id: 346,
    name: 'polka dot t-shirt',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmah4vqgF6zJYc6Urv4iZJ1wDHFDrUDabK6dCj3Z2q91Qc',
  },
  {
    id: 347,
    name: 'half-zip hoodie',
    trim: 'magic garden',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUwCLd9XAokmfXY3MzwC65KRpQjtHHtpyxhx6bo62yKzJ',
  },
  {
    id: 348,
    name: 'flamenco dress',
    trim: 'fiesta',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmQjQyBnc8MWuMG1ynQZe9hNhzuCVFTpEd9ayS49WRkrmk',
  },
  {
    id: 349,
    name: 'casual dress',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmZbQzLmwyYBY8vB8ChAXF2Nzc6eYohTCQrTXih1TS4ZCG',
  },
  {
    id: 350,
    name: 'happy logo tee',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmf96oyJz1KXAqJCfTP9u5ySG4hikTQqAcbuiGXspNcvtP',
  },
  {
    id: 351,
    name: 'happy logo tee',
    trim: 'gumball',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmVf5kPsYhv7rC5e9iFCHA4Fn8oEkC8L4YVifENfsGzfND',
  },
  {
    id: 352,
    name: 'happy logo tee',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmSQRB5QjhhbB7UUJfRVjkdUDhUchQ5K27w77Uc2ByNNrW',
  },
  {
    id: 353,
    name: 'happy logo tee',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qme4QJh3KSHHaDKxDb1EzMjudhamDHeLtjea5utNQ4gdwy',
  },
  {
    id: 354,
    name: 'happy logo tee',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPJQHUepYpziLo5Yj41k1Jss8rD8Lftx7VJq45Mzjy6RL',
  },
  {
    id: 355,
    name: 'collared sweater',
    trim: 'disco',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPHNNW3hAadKu7pBHxc7XUqHJrBKD5k2L6whfLCDsy8qy',
  },
  {
    id: 356,
    name: 'verified hoodie',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'Qmcyorocs9Kkgwx42C3qw6wzmtUCec7kBEtVegQHapYKDo',
  },
  {
    id: 357,
    name: 'big city longsleeve',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmapHQkCbd9CBQPxkF7sgwVkdUmVczDU5YqEyztCN4j1wB',
  },
  {
    id: 358,
    name: 'doodlebot torso',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'override',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmY39XSU53ihhvzMsuprNY14tbEqEVDFH3kDcxymmaCKPd',
  },
  {
    id: 359,
    name: 'tp top',
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYYqdJmTa5rS6JFDJAoatSkiN2sbpWVBTwzSMgS2snSsW',
  },
  {
    id: 360,
    name: 'introvert hoodie',
    trim: 'gumball',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWPmsoXceQgrpp6gCtVfhEhjJqRxx1kB3pzYsXmBUfh34',
  },
  {
    id: 361,
    name: 'hideout hoodie',
    trim: 'tokyo pink',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmUZp1nA4oHGCTwwa18817bt6TBaSoJHXvMWJ8kPZtAXoK',
  },
  {
    id: 362,
    name: 'collared tee',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRGfrSL6ZiPk6GXGyTj3Msw6VpQM3kZgdNfZKkyn21npA',
  },
  {
    id: 363,
    name: 'collared tee',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWFW1KrjWQinXpCQCHVb7KmEauuRcHoW5fHZKa32Wrrvv',
  },
  {
    id: 364,
    name: 'tennis tee',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmdJSUgzopoG8TH2bHhnA8u1Q4XyNgGCzwmdUmXw8T67Bi',
  },
  {
    id: 365,
    name: 'varsity hoodie',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZc3WMrF6U4R948vsdynnDBCZChJLeMGBkk3WyaHyf2X2',
  },
  {
    id: 366,
    name: 'spiked leather jacket',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWzvZ1gCHNR7X8EimFzMtuLTEWfRV1JQGVDik3xmf5YEX',
  },
  {
    id: 367,
    name: 'spiked leather jacket',
    trim: 'gold',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmX3Jnjr5KiMfLeRtjxsVR9Vt45eciQxgZYg45iaJGsVEc',
  },
  {
    id: 368,
    name: 'foam party blouse',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZteJ8D6B5GMrdbqnhkUpPUbJ8omFjt93nGfSxrrQFiEk',
  },
  {
    id: 369,
    name: 'tactical puffer',
    trim: 'coastal classic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmawGk9HEBLagD6WWj88QWUUeM7wMB8fspH1MR7qoreNgF',
  },
  {
    id: 370,
    name: 'tactical puffer',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmZCt1zQSYtqkYksTeyRxwxXv2oaMGsjqCSH8E2ZTdEKeB',
  },
  {
    id: 371,
    name: 'cardigan',
    trim: 'coastal classic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmXMcSDJLDdDW3q3jaS1T5feSdfEtKwXSYbc69VBDaacp3',
  },
  {
    id: 372,
    name: 'patchwork tee',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYjyhg21pND46HdZQqE8prELTdKjc629YXpKv9JHGhkWB',
  },
  {
    id: 373,
    name: 'patchwork tee',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmeKoSt5jhsdTiekcyemM5UmWsvSbTAkyUJMcvTFriZr4N',
  },
  {
    id: 374,
    name: 'denim jacket',
    trim: 'sky blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcxLnMCcXmHgh8xfQVWt12eAQamTtJPt97ghX2PWgC1yj',
  },
  {
    id: 375,
    name: 'sticky note tee',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmTFG5Rb5AraAuAzENac9ALmpECiESRSBZoR5FsTbt13dX',
  },
  {
    id: 376,
    name: 'sticky note tee',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmRpkNLc2TmfiRDLWjwJUy6qMJLZMRqSSoj9Uu1hNAGojG',
  },
  {
    id: 377,
    name: 'sticky note tee',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmWSr4saP6izL3hk8xPDUnXxXZhNuqKCagjXtuXdKVrV98',
  },
  {
    id: 378,
    name: 'sticky note tee',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmR7RzCfY12f3Z9kdAGFVeZ4xfSZytXq2GqDkico7oKjPL',
  },
  {
    id: 379,
    name: 'sky puffer',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmPBPVwmkJV2ptKjnwoAfap8QZf3hRKdddevJBwUQdb2um',
  },
  {
    id: 380,
    name: 'washed up tee',
    trim: 'beige',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmYAhEMwLVMKXRfkEHtS4Y3FG7e8Wa4yMgZp1peRiRTqfJ',
  },
  {
    id: 381,
    name: 'lava lamp jumper',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'chest',
    layer: 'mid layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcLBafWwZyFz3iJ7HfjJkg8dPcK6SnNiDBczicqazwV1q',
  },
  {
    id: 382,
    name: 'denim jacket',
    trim: 'black',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmcaHK7ruFge6dwGbJQ7jZyt9Pkx9r2bTh124DeF1oHV8y',
  },
  {
    id: 383,
    name: 'trench coat',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmaEAp3dPFDa2cMZW79Er76GfY64E4uSLwcCPoaSRzihRz',
  },
  {
    id: 384,
    name: 'frosty cardigan',
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'chest',
    layer: 'outer layer',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmdrQbeS8SCa7wQEzekpCPta6bQpFUfXbsGFapZJiB8sVU',
  },
  {
    id: 385,
    name: 'cashed out shorts',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUT3LgQmKVVGx3vZEFn26BKFfZuGHa8bpxyVTH17xjPt3',
  },
  {
    id: 386,
    name: 'shorts',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbvGpc21e9BbeZYTBboD3o1wwLLenpgzhsa5x5SEHF4xd',
  },
  {
    id: 387,
    name: 'heart bloomers',
    trim: 'red',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmPdfWjoW979i3MH1MrHeg6JUv9VfNuqwFSUpdc9Zctpd7',
  },
  {
    id: 388,
    name: 'smiley bloomers',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmT8YebgEvrnqFZ93G9nFq4wo1v565cmuzWGZqzC4ADPay',
  },
  {
    id: 389,
    name: 'puffer drip shorts',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmS8BfN46SLHRZLaqNLQUGCfPZygpfQTEGJE4FkgX1xpEG',
  },
  {
    id: 390,
    name: 'swim gear',
    trim: 'multi-colored',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmXGewtCRFsrKn6SSwSE2uPr9FJzjsWddAL5h1HiwoUo2d',
  },
  {
    id: 391,
    name: "alchemist's pants",
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmProvPBUGC93qGoRKx4wK6mdE2pK7VDeiXUvLHUFgbtyc',
  },
  {
    id: 392,
    name: 'fish bag pants',
    trim: 'orange',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmcfqEbY8RyiQsHVSMoYVZ7Gg1Ft4hwPVCfA8w7iuLe87J',
  },
  {
    id: 393,
    name: 'dino suit',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmV4EcaJdKPqP6r5fMAD7qYzW4JjNjSTosSguWT4LXPW9M',
  },
  {
    id: 394,
    name: 'frosty pants',
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmNQiEJ3wp5tTWom9K8JXQd6x6qEYH6zj3xAUuNoafZSSb',
  },
  {
    id: 395,
    name: 'polka dot yoga pants',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUqZgAaNQojfSw43riHmHE8b3DV9s9kcAkUfVNVuwNa2s',
  },
  {
    id: 396,
    name: 'jorts',
    trim: 'sky blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmcomV62umUiWjgL2PmeRLhovwmhCMLsriZZfa4Nnpas7T',
  },
  {
    id: 397,
    name: 'ripped jeans',
    trim: 'sky blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmPiQWQveRXTWojp6NgZozB9pTqiBjDgvtFG6k2SysbFxW',
  },
  {
    id: 398,
    name: 'puffer joggers',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmNjcx53CxC9yM9yz9jSEe8cE2SYN4g5kN7mXK4DZt7oSb',
  },
  {
    id: 399,
    name: 'puffer joggers',
    trim: 'coastal classic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmZJY4yyzsUSYMDUy8wnQda9WSeAVZyKV3N8L6yyB82Rs8',
  },
  {
    id: 400,
    name: 'spotted overalls',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'multi',
    layer: '',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmR2K6g3rPc5dVAgdGoqqxaHUCfzs7FJP6LgQdRjX3Wqda',
  },
  {
    id: 401,
    name: 'spotted overalls',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'multi',
    layer: '',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmNYj2xxSmPTrKDjhgmbneNMFvYvncj1yFHGyKEyiSobPS',
  },
  {
    id: 402,
    name: 'lit pants',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmfJ44mNC9ebNvPVVhhDQ56bfXqKA1AzJyibUqrQTDNLi5',
  },
  {
    id: 403,
    name: 'lazy overalls',
    trim: 'sky blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmdxKFZsFpuZ54b41KzDbFDDCniRkzvsXLXPzZxfGxBMMU',
  },
  {
    id: 404,
    name: 'lazy overalls',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmR5Lg1jNqwKmk52LrwhkLBQTmcxQt3DBsX8pzvDmBke58',
  },
  {
    id: 405,
    name: 'sunset trunks',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmZ5Q7QvRZSCqhT8vyEk4XAr2h25a2Yuzrqj446ffU7mQi',
  },
  {
    id: 406,
    name: 'thick stripe trousers',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmU7G48PWsi7PSXT9vqni5Qg6s9piEHzGdoytJLqNAsayc',
  },
  {
    id: 407,
    name: 'color block trousers',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmRB6afewFGNpFRanK2m3p2rREF4kSqfteWixpYFvUYZep',
  },
  {
    id: 408,
    name: 'color block trousers',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmYftpwPkHfMCASHNU2xmWYnMuuTYq3NVyNJeJAiu3gwkq',
  },
  {
    id: 409,
    name: 'striped bell-bottoms',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUZsLtgPhpDL94WqQKUa9Kvm2735t8fY67JakwbtAntgm',
  },
  {
    id: 410,
    name: 'striped bell-bottoms',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmaWtQ7KVYd3Ex1xgkGjDoGQYmzfN9JTmWSZB7N6pvdKbG',
  },
  {
    id: 411,
    name: 'slouchy sweatpants',
    trim: 'orange',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmYskqGL576dyBTJTVMFDoJTFLFxkBsDx9EogQtZnuqcgq',
  },
  {
    id: 412,
    name: 'slouchy sweatpants',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmeRCQA5srDUowzVhUNzPnjxHCaRpZn9tMkjAQBJvw1ta2',
  },
  {
    id: 413,
    name: 'parachute pants',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmQnXx5CUiExMMmynpGvBWBc2yHRAQ1pQ3BCN7MniggVU1',
  },
  {
    id: 414,
    name: 'parachute pants',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmPadfpgjAP1cUhh9afxK6XXeHcNuQFXKsF7kFVb9mY7X9',
  },
  {
    id: 415,
    name: 'royal cape',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmVhu7DSLyPYJ696ZFewNuYHo4MKhPWhBaogJcyudNdjHC',
  },
  {
    id: 416,
    name: 'royal cape',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'back',
    layer: 'accessory',
    plurality: 'FALSE',
    ipfs_hash_svg: 'QmbybneAKbCvhNpNLXRwH9unPvycH2ioWpLH76ha1vLhHt',
  },
  {
    id: 417,
    name: 'breakfast shorts',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmW3m2srUKfn4AwTAqyef6GGsJvYzv4fZjQoHNo19MxTnT',
  },
  {
    id: 418,
    name: 'breakfast shorts',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmdE8UgHKN2a8WxvvAedfASui8xD8bssmzrCbpipbW1bWt',
  },
  {
    id: 419,
    name: 'breakfast shorts',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUvncQ1CrW5H83xG2f55J3rYpED5Mkyq2ykt56hzMnJ5F',
  },
  {
    id: 420,
    name: 'paw pants',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUNP84CknGqRY7HxNRqFWgGSWAoMDU3Vtj6YFpLDrXN5d',
  },
  {
    id: 421,
    name: 'paw pants',
    trim: 'holographic',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'legs',
    layer: 'base layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmV4KE7KUCsZorNmZoc2uGgnfRSDi5oSaf9EBMrJ9hhqKz',
  },
  {
    id: 422,
    name: 'chunky loafers',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmewPDNpptV12wWepZeygqVHGJuAr2oeG7hjsU7WFh1RfH',
  },
  {
    id: 423,
    name: 'chunky loafers',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUxei2X55uj9hhjF2huJaS4udreGuaWtAxfTpwWe5qgPN',
  },
  {
    id: 424,
    name: 'trooper boots',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmXh1UbepA8LrwnaBEuB5YzpXeiVkTUAvkmE6it6yatvHA',
  },
  {
    id: 425,
    name: 'trooper boots',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbegrQP96FddaGezbgncTYxLhkcR2bLrRvJe4yqfLbCmq',
  },
  {
    id: 426,
    name: 'sheep slippers',
    trim: 'white',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmXypfyULyMUPmnXpPY1TtwD4xVCM9dnpBCZXpoc2tZ96w',
  },
  {
    id: 427,
    name: 'rainbow puke shoes',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmYRxPPPobJJ9UZGeAmn1qLmhh85z8GTW9rjp8z6o3AaVh',
  },
  {
    id: 428,
    name: 'running shoes',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'Qmdfjjdd8NSxLfFSFfknoazBNS6EK9yy4XM6TMzkkYRwPM',
  },
  {
    id: 429,
    name: 'flip flops',
    trim: 'tokyo pink',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmPe7jQFHtmNHi62FX7aXgBesc2AP1QthbFdfxiYTZt3EB',
  },
  {
    id: 430,
    name: 'piñata boots',
    trim: 'rainbow',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'Qmbk12e6PThnESCUDaaxCmr45gaohYpcQv5bwowterWjhA',
  },
  {
    id: 431,
    name: 'cleats',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmTVL4H2RaYxH5Nh5PqsCdW8Gf1Bxo9eodQ8R7JbQGbzro',
  },
  {
    id: 432,
    name: 'daisy platforms',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmWAkfce1RWqFFV7uMsipZNmChFnC3YBcmNJ1mASEkje1Q',
  },
  {
    id: 433,
    name: 'tennis shoes',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUx4eU1hgzyv3WKFqx3nFY5ZX3jJzRaTw4H1Kk1H4eGnB',
  },
  {
    id: 434,
    name: 'tennis shoes',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbmaMbU8dTe6KNeQFBqgPsdUFEwE77UXRayyAKZRvrswm',
  },
  {
    id: 435,
    name: 'zip clogs',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmcHkvqTh1TkS71bq3B7BmDRQkkhU4uu2kxF4aBGvufpSM',
  },
  {
    id: 436,
    name: 'zip clogs',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmaQSFV61yTTwUEM6QH8tgnKCB6Kfg1Csza6NpqiusVkEj',
  },
  {
    id: 437,
    name: 'fuzzy slip-ons',
    trim: 'purple',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmZ92XhpLedriXE7kyqr199FK6t6CLUuP6jtVyKmzSBNwf',
  },
  {
    id: 438,
    name: 'glitter tank shoes',
    trim: '',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'Qmay9L3pFmqpHvpyAGibCDS4yM378Eo7r2sS7JsF2f84Vy',
  },
  {
    id: 439,
    name: 'mercury fliers',
    trim: 'blue',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmSX1cyi3ZycV9GbYYdfZ133ABpzYobzxZo1CDW2mSCpac',
  },
  {
    id: 440,
    name: 'rocket skis',
    trim: 'sherbert sunrise',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmWF3vNad69gVZZdXZMWAfezykPQvC3RxAW9kgZjugvxuZ',
  },
  {
    id: 441,
    name: 'rocket skis',
    trim: 'super nova',
    set: 'Genesis Box',
    set_type: 'Grail',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmQ9H25bJfzRT9gRWm7TDAvMubxMkPjsvmhYs3KTh83M59',
  },
  {
    id: 442,
    name: 'strappy sandals',
    trim: 'green',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbxyEcyHvqsRhNqkF1gdVYPNBp8bJSFBFMVWv5BMazXvX',
  },
  {
    id: 443,
    name: 'strappy sandals',
    trim: 'fiesta',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmUnAgLuww2qF8o7veXWCH2Ye8LEyV3orvCK7JR42juM5L',
  },
  {
    id: 444,
    name: 'leather wing tips',
    trim: 'brown',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmaLYB3WN6LyrZP87idTb3pGWn6i4UuvHkCNX3JLVF3b24',
  },
  {
    id: 445,
    name: 'lion slippers',
    trim: 'yellow',
    set: 'Genesis Box',
    set_type: 'Exclusive',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmaEgVihA4KneHhgjqEs4FfKuPjYENqiHJerLncx97Xr9D',
  },
  {
    id: 446,
    name: 'octopus shoes',
    trim: 'pink',
    set: 'Genesis Box',
    set_type: '1:1',
    body_position: 'feet',
    layer: 'outer layer',
    plurality: 'TRUE',
    ipfs_hash_svg: 'QmbupteWtYdD2EZ1NiPWm3jzrYacrJ19Y6YuVu9tTj8r86',
  },
];
